import { ReactElement } from 'react';
import './App.css';

import Main from './pages/main-page/main.page';

function App(): ReactElement {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
